<template>
    <div class="scc-prize">
        <div class="scc-prize__quantity-outer-container">
            <div
                class="scc-prize__quantity-container"
                :class="highlight ? 'scc-prize__quantity-container--highlight' : ''"
            >
                <div class="scc-prize__quantity h5">{{ quantity }}x</div>
            </div>
        </div>
        <div
            ref="prizeContainer"
            class="scc-prize__container"
            @mouseover="showContainer = true"
            @mouseleave="showContainer = false"
        >
            <div class="scc-prize__main-container">
                <div class="scc-prize__image-container">
                    <div class="scc-prize__image" :style="[backgroundImage]"></div>
                </div>
                <div class="scc-prize__text">
                    <p class="scc-prize__title h5">{{ reference }}</p>
                    <div v-if="sponsor && sponsor.name" class="scc-prize__sponsor">
                        <div class="scc-prize__sponsor-icon"></div>
                        <p class="scc-prize__sponsor-text bold">{{ sponsor.name }}</p>
                    </div>
                </div>
            </div>
            <div
                v-if="description"
                class="scc-prize__sub-container"
                :class="{ 'scc-prize__sub-container--active': showContainer }"
                @click="isMobile ? (showContainer = false) : null"
            >
                <div class="scc-prize__sub-inner-container">
                    <div class="scc-prize__button">
                        <img class="scc-prize__button-close" :src="closeIcon" alt="close icon" />
                    </div>
                    <p class="scc-prize__title h5">{{ reference }}</p>
                    <p class="scc-prize__description">{{ description }}</p>
                    <div v-if="sponsor && sponsor.name" class="scc-prize__sponsor">
                        <div class="scc-prize__sponsor-icon"></div>
                        <p class="scc-prize__sponsor-text bold">{{ sponsor.name }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import './prize.scss';

export default {
    name: 'Prize',
    __editor: {
        fields: {
            image: {
                widget: 'media',
            },
        },
    },
    props: {
        id: String,
        image: {
            type: String,
            default: null,
        },
        quantity: {
            type: Number,
            default: 1,
        },
        reference: {
            type: String,
            default: '',
        },
        description: {
            type: String,
            default: '',
        },
        sponsor: {
            type: Object,
            default() {
                return null;
            },
        },
        highlight: Boolean,
    },
    data() {
        return {
            closeIcon: require('@/assets/icons/close.svg'),
            showContainer: false,
        };
    },
    computed: {
        isMobile() {
            return window.innerWidth < 1024;
        },
        backgroundImage() {
            return {
                backgroundImage: `url(${this.image})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
            };
        },
    },
};
</script>
